// extracted by mini-css-extract-plugin
module.exports = {"circles":"RecommendationSection_circles__mGhxU","circle":"RecommendationSection_circle__Mb1eE"};